import Vue from 'vue'
import './plugins/vuetify'
import 'vuetify/dist/vuetify.min.css'
import App from './App.vue'
import router from './router'
import store from './store'
require('dotenv').config();
import './registerServiceWorker'
import VueJWT from 'vuejs-jwt'
import VModal from 'vue-js-modal'
import EditYaml from './components/edityamlpage.vue'
import textReader from './components/yaml.vue'
import Opengraph from './components/opengraph'
import ClassModeling from './components/designer/class-modeling'
import Modeling from './components/designer/modeling'
import KubeModeling from './components/designer/k8s-modeling'
import StickyModeling from './components/designer/sticky-modeling'
import BusinessModeling from "./components/designer/business-model-canvas";
import EventStormingModeling from "./components/designer/es-modeling";
import HexagonalModeling from "./components/designer/hexagonal-architecture";
import ProvisionIndication from "./components/payment/ProvisionIndication";
import ParticipantPanel from "./components/designer/modeling/ParticipantPanel";
import ModelStorageDialog from "./components/designer/modeling/ModelStorageDialog";
import VueGtag from 'vue-gtag'
import IDEResourceDialog from "./components/IDEResourceDialog";
import terminalLoadingPage from "./components/terminalLoadingPage";
import VueSuperMethod from 'vue-super-call'
import GitInformation from "./components/GitInformation";

import PurchaseItemTemplate from "./components/payment/PurchaseItemTemplate";
import BlurPurchaseItem from "./components/payment/BlurPurchaseItem";
import DialogPurchaseItem from "./components/payment/DialogPurchaseItem";
import AutoPaymentComposition from "./components/payment/AutoPaymentComposition";
// import PurchaseItemDialog from "./components/payment/PurchaseItemDialogOrigin";
// import BlurPurchaseItem from "./components/payment/BlurPurchaseItemOrigin";
import SeparatePanelComponents from "./components/SeparatePanelComponents";

import BusinessModelPanel from "./components/designer/business-model-canvas/BusinessModelPanel";
import EventStormingModelPanel from "./components/designer/es-modeling/EventStormingModelPanel";
import PurchaseItem from "./components/payment/PurchaseItem";
import InstructionHtml from "./components/InstructionHtml";
import PersonalInfo from "./components/oauth/PersonalInfo";
import LoginAcebase from './components/oauth/LoginByAcebase';
import Login from './components/oauth/Login';
import LoginGitlab from './components/oauth/LoginByGitlab';
// let Login = require(loginModule);
import Mustache from 'mustache'
import handleBars from 'handlebars';

import firebase from "firebase/app";
import VueFriendlyIframe from 'vue-friendly-iframe';
import {TrackJS} from 'trackjs';
import CodeMirror from 'vue-codemirror'
import VueYouTubeEmbed from 'vue-youtube-embed'
import vuetify from './plugins/vuetify';
import {Icon} from '@iconify/vue2';

import 'vue-simple-context-menu/dist/vue-simple-context-menu.css'
import VueSimpleContextMenu from 'vue-simple-context-menu'
import {WebRTC} from 'vue-webrtc'
import * as VueWindow from '@hscmap/vue-window'
// import BusinessModelEditor from "./components/designer/business-model-canvas/BusinessModelEditor";
import i18n from './i18n'
//base
//designer
import ViewCreate from './components/designer/view-modeling/ViewCreate'
import ViewUpdate from './components/designer/view-modeling/ViewUpdate'
import ViewDelete from './components/designer/view-modeling/ViewDelete'
import ParticipantListsPanel from "./components/designer/modeling/ParticipantPanel";
import ViewModelingDesigner from "./components/designer/modeling/ViewModelingDesigner";
import vClickOutside from "v-click-outside";
Vue.use(vClickOutside);
//list
import ProjectCard from "./components/EventStormingList/ProjectCard";
import ListCard from "./components/EventStormingList/ListCard";
import EventStormingListPage from "./components/listPages/EventStormingListPage";
import ClazzListPage from "./components/labs/ClazzListPage";
import PaymentChoice from "./components/payment/PaymentChoice";
import VRuntimeTemplate from "v-runtime-template";

import 'vue-resize/dist/vue-resize.css'
import {ResizeObserver} from 'vue-resize'

//bpmn
import BpmnProcessDesigner from "./components/designer/bpmnModeling/ProcessDesigner";
import BpmnVue from "./components/designer/bpmnModeling/bpmn";
import ObjectGrid from "./components/designer/bpmnModeling/ObjectGrid";
import ObjectForm from "./components/designer/bpmnModeling/ObjectForm";
import VueMarkdown from 'vue-markdown';
import VueSimplemde from 'vue-simplemde'
import 'simplemde/dist/simplemde.min.css';
import VeeValidate from 'vee-validate';
import VueMeta from 'vue-meta'

import TreeView from 'vue-json-tree-view'

//cookies
import VueCookies from "vue-cookies";
Vue.use(VueCookies);
Vue.$cookies.config("7d");

var JsonDiff = require('jsondiffpatch').create({
    objectHash: function (obj, index) {
        return '$$index:' + index;
    },
});

Vue.use(VueMeta)
Vue.use(VeeValidate);
Vue.use(VueFriendlyIframe);
Vue.use(VueWindow)
Vue.use(Mustache)
Vue.use(CodeMirror)
Vue.use(Opengraph);
Vue.use(ClassModeling);
Vue.use(Modeling);
Vue.use(KubeModeling)
Vue.use(StickyModeling);
Vue.use(BpmnVue);
Vue.use(BusinessModeling);
Vue.use(EventStormingModeling);
Vue.use(HexagonalModeling);
Vue.use(VModal);
Vue.use(handleBars);
Vue.use(VueGtag, {
    config: {id: process.env.VUE_APP_FIREBASE_trackingId},
});


Vue.component('VueMarkdown', VueMarkdown)
Vue.component(WebRTC.name, WebRTC)
Vue.component('EditYaml', EditYaml)
Vue.component('text-reader', textReader)
Vue.component('GitlabLogin', LoginGitlab)
if(window.MODE == "onprem") {
    Vue.component('Login', LoginAcebase)
    // Vue.component('Login', LoginGitlab)
} else {
    // Vue.component('Login', LoginGitlab)
    Vue.component('Login', Login)
}
Vue.component('ViewCreate', ViewCreate)
Vue.component('ViewUpdate', ViewUpdate)
Vue.component('ViewDelete', ViewDelete)
Vue.component('ProjectCard', ProjectCard)
Vue.component('ListCard', ListCard)
Vue.component('ModelingPropertyPanel', EventStormingModelPanel)
Vue.component('BusinessPropertyPanel', BusinessModelPanel)
Vue.component('ParticipantListsPanel', ParticipantListsPanel)
Vue.component('ViewModelingDesigner', ViewModelingDesigner)
Vue.component('purchase-item', PurchaseItem)
Vue.component('instruction-html', InstructionHtml)
Vue.component('provision-indication', ProvisionIndication)
Vue.component('participant-panel', ParticipantPanel)
Vue.component('purchase-item-template', PurchaseItemTemplate)
Vue.component('blur-purchase-item', BlurPurchaseItem)
Vue.component('dialog-purchase-item', DialogPurchaseItem)
Vue.component('personal-info', PersonalInfo)
Vue.component('auto-payment-composition', AutoPaymentComposition)
Vue.component('model-storage-dialog', ModelStorageDialog)
Vue.component('ide-resource-dialog', IDEResourceDialog)
Vue.component('project-list', EventStormingListPage)
// Vue.component('project-list', EventStormingListPages)
Vue.component('class-list', ClazzListPage)
Vue.component('v-runtime-template', VRuntimeTemplate)
Vue.component('payment-choice', PaymentChoice)
Vue.component('Icon', Icon);
Vue.component('vue-simplemde', VueSimplemde)
Vue.component('vue-simple-context-menu', VueSimpleContextMenu)
Vue.component('bpmn-process-designer', BpmnProcessDesigner)
Vue.component('object-grid', ObjectGrid);
Vue.component('object-form', ObjectForm);
Vue.component('terminal-page', terminalLoadingPage);
Vue.component('git-information', GitInformation);
Vue.component('separate-panel-components',SeparatePanelComponents)
Vue.component('resize-observer', ResizeObserver)

////////////////////////////////
// const SeparatePanelComponents = ()=>
//     import(/* webpackChunkName: "SeparatePanelComponents" */ './components/SeparatePanelComponents')

////////////////////////////////

// setting locale
try{
    window.countryCode = 'ko'

    $.getJSON("https://ipinfo.io", function (data) {
        var country = data.country // 접속자 국가
        if (country == "KR") {
            window.countryCode = 'ko'
        } else {
            window.countryCode = 'en'
        }
    });
}catch (e) {
    window.countryCode = 'ko'
}

require('../public/global-style.css');
// Vue.use(Metaworks4);


//IAMPort Pay
try{
    var IMP = window.IMP;
    IMP.init(`${process.env.VUE_APP_IAMPORT_ImpKey}`)
}catch (e) {
    console.log('Network disconnected.')

}

var options = {'keyName': 'accessToken'};
var Minio = require('minio');
// Vue.component('vue-context-menu', VueSimpleContextMenu)
Vue.use(VueJWT, options)
Vue.use(VueYouTubeEmbed, {global: true, componentId: "youtube-media"})
process.env.NODE_TLS_REJECT_UNAUTHORIZED = "0";

Vue.prototype.$EventBus = new Vue()
Vue.prototype.$ModelingBus = new Vue()
Vue.prototype.$JsonDiff = JsonDiff
Vue.prototype.$super = VueSuperMethod

Vue.use(TreeView)

function getTenantId() {
    var urlStr = window.location;
    var url = new URL(urlStr);

    var tenantId = url.hostname;
    if (tenantId.includes(".")) {
        tenantId = tenantId.substring(tenantId.indexOf(".") + 1)
    }
    return tenantId;  //www.gklabs.co.kr?  -->
}

Vue.prototype.$minioClient = new Minio.Client({
    endPoint: `minio.${getTenantId()}`,
    useSSL: true,
    accessKey: "minio",
    secretKey: "minio123"
})


// TrackJS.install({
//     token: "c57ef0e614dd477bb035e6a50522c4bc",
//     application: "eventstorming2code"
//     // for more configuration options, see https://docs.trackjs.com
// });

// TrackJS.track('Testing TrackJS!');

window.$Mustache = Mustache;
window.$HandleBars = handleBars;

// TrackJS -- Error Logging
var firebaseConfig = {
    apiKey: process.env.VUE_APP_FIREBASE_apiKey,
    authDomain: process.env.VUE_APP_FIREBASE_authDomain,
    databaseURL: process.env.VUE_APP_FIREBASE_databaseURL,
    projectId: process.env.VUE_APP_FIREBASE_projectId,
    storageBucket: process.env.VUE_APP_FIREBASE_storageBucket,
    messagingSenderId: process.env.VUE_APP_FIREBASE_messagingSenderId,
    appId: process.env.VUE_APP_FIREBASE_appId,
    measurementId: process.env.VUE_APP_FIREBASE_measurementId
};

var mongoConfig = {
    id: process.env.VUE_APP_MONGODB_ID,
    password: process.env.VUE_APP_MONGODB_PASSWORD
}

Vue.prototype.$mongodb = mongoConfig;

firebase.initializeApp(firebaseConfig);
// firebase.analytics();
if (process.env.NODE_ENV == "development") {
    window.API_HOST = "35.200.104.173";
} else {
    window.API_HOST = process.env.VUE_APP_API_HOST
}
window.vueFilePath = process.env.VUE_APP_FILE_PATH

window.distributeMinioPath = process.env.VUE_APP_MINIO_DISTRIBUTE
// // console.log(templateFiles.keys())


/////////////// template /////////////////////
const templateFiles = require.context('../public/static/templates', true)
var tempRootPathList = []
templateFiles.keys().forEach(function (tempFiles) {

    console.log("template :  " + tempFiles)
    var tempFileStructure = tempFiles.replace('./', '').split('/')
    tempRootPathList.push(tempFileStructure[0])
})
tempRootPathList.push('Custom Template')


var tempRootPath = new Set(tempRootPathList)
var rootPathList = Array.from(tempRootPath)

Vue.prototype.$manifestsPerTemplate = {};


rootPathList.forEach(function (item) {
    eval('Vue.prototype.$manifestsPerTemplate[\"' + item + '\"] = []')
})


templateFiles.keys().forEach(function (tempFiles) {
    console.log(tempFiles)
    var tempFileStructure = tempFiles.replace('./', '').split('/')
    var rootName = tempFileStructure[0]
    // console.log(rootName)
    var tmp;
    // // console.log(tempFiles.replace)
    eval('tmp' + '= tempFiles.replace(\"' + rootName + '\/\",\"\"\)')
    eval('Vue.prototype.$manifestsPerTemplate[\"' + rootName + '\"].push(tmp)')
})
//////////////////////////////////////////

//////////////////// toppings /////////////
const toppingFiles = require.context('../public/static/toppings', true)
var toppingRootPathList = []

toppingFiles.keys().forEach(function (toppingFile) {
    console.log("topping :  " + toppingFile)
    var tempFileStructure = toppingFile.replace('./', '').split('/')
    toppingRootPathList.push(tempFileStructure[0])
})

var toppingRootPath = new Set(toppingRootPathList)
var toppingRootPathLists = Array.from(toppingRootPath)

// // console.log(rootPathList)
Vue.prototype.$manifestsPerToppings = {};

toppingRootPathLists.forEach(function (item) {
    eval('Vue.prototype.$manifestsPerToppings[\"' + item + '\"] = []')
})
toppingFiles.keys().forEach(function (tempFiles) {
    var tempFileStructure = tempFiles.replace('./', '').split('/')
    var rootName = tempFileStructure[0]
    var tmp;
    eval('tmp' + '= tempFiles.replace(\"' + rootName + '\/\",\"\"\)')
    eval('Vue.prototype.$manifestsPerToppings[\"' + rootName + '\"].push(tmp)')
})
////////////////////////////////////////////////


Vue.prototype.$innerWidth = window.innerWidth;
Vue.prototype.$innerHeight = window.innerHeight;


Vue.config.productionTip = false

new Vue({
    router,
    store,
    vuetify,
    i18n,
    WebRTC,
    render: function (h) {
        return h(App)
    }

}).$mount('#app')

